import React from 'react';
import { Box, Typography } from '@mui/material';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import { brandColors } from '@config/brandTokens';

export type ProfileStill = {
  url: string;
  alt?: string;
};

const placeholderTiles = [
  { bg: brandColors.navy, opacity: 0.92 },
  { bg: brandColors.blue, opacity: 0.55 },
  { bg: '#1c2758', opacity: 0.88 },
  { bg: '#3d5ed4', opacity: 0.42 },
];

const ProfilePhotoCollage: React.FC<{
  photos?: ProfileStill[];
  playerName?: string;
}> = ({ photos = [], playerName = 'Player' }) => {
  const tiles = photos.filter((item) => item.url).slice(0, 4);
  const empty = tiles.length === 0;

  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 800,
          color: brandColors.navy,
          fontSize: 13,
          mb: 0.75,
          fontFamily: '"Sora", Arial, sans-serif',
        }}
      >
        Photos
      </Typography>
      <Box
        sx={{
          width: empty ? 220 : '100%',
          maxWidth: 340,
          display: 'grid',
          gridTemplateColumns: empty || tiles.length >= 2 ? (tiles.length === 3 ? '1.25fr 1fr' : '1fr 1fr') : '1fr',
          gridTemplateRows: empty ? '44px 44px' : tiles.length === 1 ? '120px' : '72px 72px',
          gap: 0.5,
          borderRadius: 1.25,
          overflow: 'hidden',
          border: '1px solid #e2e8f0',
          bgcolor: brandColors.navy,
          minHeight: empty ? 92 : undefined,
        }}
      >
        {empty
          ? placeholderTiles.map((tile, index) => (
              <Box
                key={`empty-${index}`}
                sx={{
                  bgcolor: tile.bg,
                  opacity: tile.opacity,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {index === 0 ? (
                  <PhotoLibraryOutlinedIcon sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 18 }} />
                ) : null}
              </Box>
            ))
          : tiles.map((tile, index) => (
              <Box
                key={`${tile.url}-${index}`}
                sx={{
                  gridRow: tiles.length === 3 && index === 0 ? '1 / span 2' : undefined,
                  minHeight: 0,
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src={tile.url}
                  alt={tile.alt || `${playerName} still`}
                  sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              </Box>
            ))}
      </Box>
      {empty ? (
        <Typography variant="caption" sx={{ color: brandColors.slate, fontWeight: 700, display: 'block', mt: 0.6 }}>
          Photos coming soon
        </Typography>
      ) : null}
    </Box>
  );
};

export default ProfilePhotoCollage;
